import { useIntl } from '@capsicum/common';
import { CurrencyType, useWalletWithdrawDetails } from '@capsicum/features/wallet/shared';

import { useWithdrawPageActions } from '../../hooks';
import { CurrencyActionCard } from '../../ui';
import { S } from '../styles';

export const Withdraw = () => {
	const { $t } = useIntl();
	const { chilizInfo, fanTokensInfo, isLoading, withdrawFanTokens } = useWalletWithdrawDetails();
	const { handleCHZCardClick, handleFanTokensCardClick } = useWithdrawPageActions({
		chilizInfo,
		fanTokensInfo,
		withdrawFanTokens
	});

	const withdrawalTexts = {
		title: $t('wallet.withdraw.title')
	};

	return (
		<S.Container>
			<S.Title>{withdrawalTexts.title}</S.Title>
			<CurrencyActionCard
				currency={CurrencyType.CHILIZ}
				disabledCHZ={!chilizInfo.hasEnoughCHZAvailabletoWithdraw}
				isLoading={isLoading}
				testID="withdraw-chiliz-card"
				texts={chilizInfo}
				onClick={handleCHZCardClick}
			/>
			<CurrencyActionCard
				currency={CurrencyType.FANTOKENS}
				isLoading={isLoading}
				logos={withdrawFanTokens}
				testID="withdraw-fanToken-card"
				texts={fanTokensInfo}
				onClick={handleFanTokensCardClick}
			/>
		</S.Container>
	);
};
